// Rotas em que o vendedor pode estar com uma ligação no ar (softphone WebRTC).
// Duas leituras dependem disto:
//
// 1. o layout recolhe a sidebar nessas telas (`app-layout.tsx`);
// 2. o app NÃO se atualiza sozinho nelas (`app-updater.tsx`) — `use-terminate-on-unload`
//    encerra a sessão SIP no `pagehide`, então qualquer reload derruba a ligação
//    com o cliente na linha. A atualização espera o vendedor sair da tela.
//
// `/call` e `/click-to-call-hubspot` entram aqui porque montam a mesma
// `TempCallScreen`, que também usa `useSoftphone` — são o click-to-call vindo do
// HubSpot, fora do layout com sidebar mas igualmente com ligação no ar.
export const CALL_WORKSPACE_PATHS = [
  "/phone",
  "/dialer",
  "/call",
  "/click-to-call-hubspot",
  "/campaigns",
];

export function isCallWorkspacePath(pathname: string): boolean {
  return CALL_WORKSPACE_PATHS.includes(pathname) || pathname.startsWith("/campaigns/");
}
